/* eslint-disable @typescript-eslint/no-explicit-any */
import { ServicingMAJCOM } from "../../../utils/controls/select-options-data"
import { mpfRListsHttp } from "../api/mpf-r-lists-http"
import { isArchivedFilter } from "./data"

interface PointsOfContact {
  AssignedComponent: string
  AssignedComponentCode: null | number
  DutyTitle: string
  IsArchived: boolean
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date
  ItemModifiedBy: any //Person_Single
  MAJCOM: string
  MAJCOMCode: null | number
  PhoneNumber: string
  PhoneNumber2: string
  PointOfContact: string
  Section: string
  SectionCode: null | number
  ServicingOrganization: string
  Title: string
}
interface PointsOfContactArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  AssignedComponent: 'AssignedComponent/MetadataValue',
  AssignedComponentCode: 'AssignedComponentCode',
  DutyTitle: 'DutyTitle',
  EKey: 'eKey',
  ETag: 'eTag',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  PhoneNumber: 'PhoneNumber',
  PhoneNumber2: 'PhoneNumber2',
  PointOfContact: 'PointOfContact',
  PointOfContactEDIPI: 'PointOfContact/edipi',
  PointOfContactEmail: 'PointOfContact/email',
  PointOfContactFirstName: 'PointOfContact/firstname',
  PointOfContactLastName: 'PointOfContact/lastname',
  Section: 'Section',
  SectionCodes: 'SectionCodes',
  ServicingMAJCOM: 'ServicingMAJCOM/MetadataValue',
  ServicingMAJCOMCode: 'ServicingMAJCOMCode',
  Squadron: 'Squadron',
  Title: 'Title',
}
const LIST_NAME = 'PointsOfContactList'

const getPointsOfContact = async (
  args: PointsOfContactArgs
): Promise<PointsOfContact[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? false
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemModified

  const items = await list
    .query()
    .select(...Object.values(COLUMN_NAMES))
    .filter(filter)
    .expand(
      'PointOfContact', 
      'ItemModifiedBy',
      'ItemCreatedBy',
      'AssignedComponent',
      'ServicingMAJCOM'
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

    items.forEach((element: Announcement) => {
      element.Section = JSON.parse(element.Section)
      element.SectionCodes = JSON.parse(element.SectionCodes)
    })

    return [...items] as PointsOfContact[]
} 

const addOrUpdatePointOfContact = async (addObj) => {
  try {
    const andList = await mpfRListsHttp().getList(LIST_NAME)
    await andList.addOrUpdateItem(addObj)
  } catch (error) {
    console.error(error)
  }
}

const deletePointOfContact = async (poc) => {
  const lists = await mpfRListsHttp().getList(LIST_NAME)
  await lists.deleteItem(poc.eKey, poc.eTag)
}

export {
  COLUMN_NAMES,
  LIST_NAME,
  type PointsOfContact,
  type PointsOfContactArgs,
  addOrUpdatePointOfContact,
  deletePointOfContact,
  getPointsOfContact,
}